export default __webpack_public_path__ + "static/media/laboratory.14569722.webp";